export default __webpack_public_path__ + "static/media/article_small.5e9b8650.svg";